import React, { useEffect, useRef } from "react";
import avatarImg from "../assets/logo_full.png";

const Home = () => {
  const designCanvasRef = useRef(null);

  const scrollToServices = () => {
    const el = document.getElementById("services");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const canvas = designCanvasRef.current;
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.src = avatarImg;

    let animationFrameId;
    let angle = 0;

    const drawAvatarCircle = () => {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;

      if (width <= 0 || height <= 0) {
        animationFrameId = requestAnimationFrame(drawAvatarCircle);
        return;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.clearRect(0, 0, width, height);

      const centerX = width / 2;
      const centerY = height / 2;

      const floatingOffset = Math.sin(angle) * 10;
      const circleRadius = Math.max(5, width / 2 - 5);

      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, "#F43F5E");
      gradient.addColorStop(0.5, "#EF4444");
      gradient.addColorStop(1, "#F87171");

      ctx.beginPath();
      ctx.arc(centerX, centerY + floatingOffset, circleRadius, 0, Math.PI * 2);
      ctx.lineWidth = 8;
      ctx.strokeStyle = gradient;
      ctx.stroke();

      const avatarSize = Math.max(20, width * 0.7);

      ctx.save();
      ctx.beginPath();
      ctx.arc(centerX, centerY + floatingOffset, avatarSize / 2, 0, Math.PI * 2);
      ctx.closePath();
      ctx.clip();

      if (img.complete && img.naturalHeight !== 0) {
        ctx.drawImage(
          img,
          centerX - avatarSize / 2,
          centerY - avatarSize / 2 + floatingOffset,
          avatarSize,
          avatarSize
        );
      }

      ctx.restore();

      angle += 0.02;
      animationFrameId = requestAnimationFrame(drawAvatarCircle);
    };

    img.onload = () => {
      drawAvatarCircle();
    };

    if (img.complete) {
      drawAvatarCircle();
    }

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  return (
    <section
      id="home"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
        fontFamily: "'Arial', sans-serif",
        background: "transparent",
        position: "relative"
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px,1fr))",
          gap: "50px",
          alignItems: "center",
          marginBottom: "40px"
        }}
      >
        <div style={{ textAlign: "left" }}>

          {/* ✅ SEO Optimized H1 */}
          <h1
            style={{
              fontSize: "clamp(2rem, 5vw, 3.5rem)",
              fontWeight: 700,
              lineHeight: 1.2,
              marginBottom: "0.8rem",
              color: "#111"
            }}
          >
            Global Digital Agency for Web, Mobile & Automation Solutions
          </h1>

          {/* ✅ Supporting H2 (SEO boost) */}
          <h2
            style={{
              fontSize: "clamp(1.2rem, 2vw, 1.6rem)",
              fontWeight: 500,
              marginBottom: "1rem",
              color: "#444"
            }}
          >
            Creative Digital Agency Helping Businesses Grow Through Web & Digital Solutions
          </h2>

          {/* ✅ Optimized Paragraph */}
          <p
            style={{
              fontSize: "clamp(1rem, 1.5vw, 1.2rem)",
              marginBottom: "2.5rem",
              color: "#222",
              lineHeight: 1.6,
              maxWidth: "500px"
            }}
          >
            We deliver top-quality web development, mobile apps, automation, and
            creative digital solutions to help your business grow. Bring your
            ideas to life with innovation, performance, and creativity.
          </p>

          <button
            onClick={scrollToServices}
            style={{
              padding: "14px 36px",
              borderRadius: "40px",
              border: "none",
              background: "linear-gradient(135deg,#F43F5E,#EF4444,#F87171)",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "1rem",
              cursor: "pointer",
              boxShadow: "0 6px 18px rgba(0,0,0,0.15)"
            }}
          >
            Explore Our Services
          </button>
        </div>

        {/* Avatar section unchanged */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px"
            }}
          >
            <div
              style={{
                width: "clamp(220px, 30vw, 360px)",
                aspectRatio: "1/1",
                borderRadius: "50%",
                overflow: "hidden",
                boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
              }}
            >
              <canvas
                ref={designCanvasRef}
                style={{
                  width: "100%",
                  height: "100%"
                }}
              />
            </div>

            <span
              style={{
                fontSize: "clamp(30px, 4.5vw, 42px)",
                fontWeight: "700",
                letterSpacing: "3px",
                textTransform: "uppercase",
                color: "#2f2f2f"
              }}
            >
              PYRUX
            </span>

            <span
              style={{
                fontSize: "clamp(13px, 1.3vw, 15px)",
                color: "#666",
                letterSpacing: "2px",
                textTransform: "uppercase"
              }}
            >
              We Build. You Grow.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;